import { InvoicePayerType } from 'store/models/invoices';
import { PayerFilterType } from 'store/models/payers';

export const PAYERS_FILTER_TYPES_INT = [
    PayerFilterType.EmployerId,
    PayerFilterType.HHId,
    PayerFilterType.UserId,
    PayerFilterType.AccountId,
];

export const PAYERS_FILTER_TYPES = [
    PayerFilterType.EmployerId,
    PayerFilterType.HHId,
    PayerFilterType.UserId,
    PayerFilterType.AccountId,
    PayerFilterType.Title,
];

export const PAYERS_FILTER_PAYER_TYPES = [
    InvoicePayerType.Legal,
    InvoicePayerType.Individual,
    InvoicePayerType.Natural,
];
